import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { orderStatus } from "@/js/lists.ts";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import CarrierFormModal from "@/components/shipping/CarrierFormModal.vue";
export default {
  name: "OderShipmentsList",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    CarrierFormModal: CarrierFormModal
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    withAddbutton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialog: false,
      shipmentsHeaders: [{
        text: "Label",
        value: "label",
        align: "left"
      }, {
        text: "Carrier",
        value: "carrierName",
        align: "left"
      }, {
        text: "Tracking",
        value: "tracking",
        align: "left"
      }, {
        text: "Currently Tracked",
        value: "tracked",
        align: "left"
      }, {
        text: "Actions",
        value: "actions",
        align: "center"
      }],
      shipments: [],
      trackingForm: {
        inputTrackingNumber: null,
        inputTrackingLink: null,
        carrier: null,
        label: null,
        tracked: false,
        idShipment: null,
        valid: false
      },
      shipmentIsLoading: false,
      updateShipmentToken: null,
      addShipmentToken: null,
      deleteShipmentToken: null,
      fetchShipmentsToken: null,
      carriers: [],
      renderCarriers: false,
      deletingCarrier: {
        isPending: false,
        cancellationToken: null
      },
      editingCarrier: {
        id: null
      },
      rules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isCancelled: function isCancelled() {
      return this.order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.fetchShipments();
          case 2:
            _context.next = 4;
            return _this2.fetchCarriers();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open(idShipment) {
      var _this$order;
      this.clearForm();
      this.dialog = true;
      var shipment = (_this$order = this.order) === null || _this$order === void 0 || (_this$order = _this$order.shipments) === null || _this$order === void 0 ? void 0 : _this$order.find(function (s) {
        return s.id === idShipment;
      });
      if (shipment) {
        var _this$carriers;
        this.trackingForm = _objectSpread(_objectSpread({}, this.trackingForm), {}, {
          inputTrackingNumber: shipment.trackingNumber,
          inputTrackingLink: shipment.trackingLink,
          carrier: (_this$carriers = this.carriers) === null || _this$carriers === void 0 ? void 0 : _this$carriers.find(function (c) {
            return c.id === shipment.idCarrier;
          }),
          label: shipment.label,
          tracked: shipment.tracked,
          idShipment: shipment.id,
          valid: true
        });
      }
    },
    cancel: function cancel() {
      this.dialog = false;
      this.clearForm();
    },
    clearForm: function clearForm() {
      this.trackingForm = {
        inputTrackingNumber: null,
        inputTrackingLink: null,
        label: null,
        tracked: false,
        idShipment: null,
        valid: false
      };
    },
    fetchCarriers: function fetchCarriers() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              data = {
                active: true
              };
              _context2.next = 4;
              return request("/v1/carriers/all", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get carriers.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this.carriers = response.data;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchShipments: function fetchShipments() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$fetchShipments;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this4;
              (_this4$fetchShipments = _this4.fetchShipmentsToken) === null || _this4$fetchShipments === void 0 || _this4$fetchShipments.cancel();
              _this4.fetchShipmentsToken = axios.CancelToken.source();
              _context3.next = 5;
              return request("/v1/orders/".concat(_this.order.id_order, "/shipments"), "get", {}, true, "api", null, _this4.fetchShipmentsToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get shipments.", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 5:
              response = _context3.sent;
              _this.shipments = response.data;
              _this.order.shipments = response.data;
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    manageSubmit: function manageSubmit() {
      if (this.trackingForm.idShipment) {
        this.updateShipment();
      } else {
        this.addShipment();
      }
    },
    updateShipment: function updateShipment() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this5$updateShipment;
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.shipmentIsLoading = true;
              (_this5$updateShipment = _this5.updateShipmentToken) === null || _this5$updateShipment === void 0 || _this5$updateShipment.cancel();
              _this5.updateShipmentToken = axios.CancelToken.source();
              _this = _this5;
              _context5.next = 6;
              return request("/v1/orders/".concat(_this.order.id_order, "/shipment/").concat(_this.trackingForm.idShipment), "put", {
                TrackingNumber: _this.trackingForm.inputTrackingNumber,
                TrackingLink: _this.trackingForm.inputTrackingLink,
                Label: _this.trackingForm.label,
                IdCarrier: _this.trackingForm.carrier.id,
                Tracked: _this.trackingForm.tracked
              }, true, "api", null, _this5.updateShipmentToken).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return _this.fetchShipments();
                      case 2:
                        _this.$emit("shipmentsChanged", _this.shipments);
                        _this.cancel();
                      case 4:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update tracking.", true);
                  handleErrorData(_this, errorData);
                }
                _this.shipmentIsLoading = false;
                throw e;
              });
            case 6:
              _this5.shipmentIsLoading = false;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    addShipment: function addShipment() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this6$addShipmentTok;
        var _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.shipmentIsLoading = true;
              (_this6$addShipmentTok = _this6.addShipmentToken) === null || _this6$addShipmentTok === void 0 || _this6$addShipmentTok.cancel();
              _this6.addShipmentToken = axios.CancelToken.source();
              _this = _this6;
              _context7.next = 6;
              return request("/v1/orders/".concat(_this.order.id_order, "/shipment"), "post", {
                TrackingNumber: _this.trackingForm.inputTrackingNumber,
                TrackingLink: _this.trackingForm.inputTrackingLink,
                Label: _this.trackingForm.label,
                IdCarrier: _this.trackingForm.carrier.id,
                Tracked: _this.trackingForm.tracked
              }, true, "api", null, _this6.addShipmentToken).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(res) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return _this.fetchShipments();
                      case 2:
                        _this.$emit("shipmentsChanged", _this.shipments);
                        _this.cancel();
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to add tracking.", true);
                  handleErrorData(_this, errorData);
                }
                _this.shipmentIsLoading = false;
                throw e;
              });
            case 6:
              _this6.shipmentIsLoading = false;
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    deleteShipment: function deleteShipment() {
      var _this = this;
      this.shipmentIsLoading = true;
      var confirmMessage = "Are you sure you want to delete this shipment ?";
      this.$refs.confirm.open("Delete", confirmMessage, {
        color: "red"
      }).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(confirm) {
          var _this$deleteShipmentT;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                if (confirm) {
                  _context9.next = 2;
                  break;
                }
                return _context9.abrupt("return");
              case 2:
                (_this$deleteShipmentT = _this.deleteShipmentToken) === null || _this$deleteShipmentT === void 0 || _this$deleteShipmentT.cancel();
                _this.deleteShipmentToken = axios.CancelToken.source();
                _context9.next = 6;
                return request("/v1/orders/".concat(_this.order.id_order, "/shipment/").concat(_this.trackingForm.idShipment), "delete", {}, true, "api", null, _this.deleteShipmentToken).then(/*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(res) {
                    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          _context8.next = 2;
                          return _this.fetchShipments();
                        case 2:
                          _this.$emit("shipmentsChanged", _this.shipments);
                          _this.cancel();
                        case 4:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8);
                  }));
                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }()).catch(function (e) {
                  if (!axios.isCancel(e)) {
                    var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete shipment.", true);
                    _this.$toasted.show(errorData.message, {
                      type: errorData.type
                    });
                  }
                });
              case 6:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.shipmentIsLoading = false;
    },
    openEditCarrierPopin: function openEditCarrierPopin(item) {
      var _this7 = this;
      this.editingCarrier.id = item.id;
      this.$nextTick(function () {
        _this7.$refs.carrierFormModal.open();
      });
    },
    openNewCarrierPopin: function openNewCarrierPopin() {
      var _this8 = this;
      this.editingCarrier.id = null;
      this.$nextTick(function () {
        _this8.$refs.carrierFormModal.open();
      });
    },
    handleCarriersUpdated: function handleCarriersUpdated(carrierId) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this9$carriers;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this9.fetchCarriers();
            case 2:
              _this9.trackingForm.carrier = (_this9$carriers = _this9.carriers) === null || _this9$carriers === void 0 ? void 0 : _this9$carriers.find(function (x) {
                return x.id === +carrierId;
              });
              _this9.renderCarriers = !_this9.renderCarriers;
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    confirmDeleteCarrier: function confirmDeleteCarrier(item) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this10.$refs.confirm.open("Delete carrier ?", "Are you sure to delete this carrier ?");
            case 2:
              ok = _context11.sent;
              if (ok) {
                _this10.deleteCarrier(item);
              }
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    deleteCarrier: function deleteCarrier(item) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this11$deletingCarri;
        var _this;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this11.deletingCarrier.isPending = true;
              (_this11$deletingCarri = _this11.deletingCarrier.cancellationToken) === null || _this11$deletingCarri === void 0 || _this11$deletingCarri.cancel();
              _this11.deletingCarrier.cancellationToken = axios.CancelToken.source();
              _this = _this11;
              _context12.next = 6;
              return request("/v1/carriers/".concat(item.id), "delete", null, true, "api", null, _this11.deletingCarrier.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.deletingCarrier.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete carrier.", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              _this11.$toasted.show("Carrier deleted.", {
                type: "success"
              });
              _context12.next = 9;
              return _this11.fetchCarriers();
            case 9:
              _this11.deletingCarrier.isPending = false;
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    }
  },
  watch: {
    "order.shipments.length": {
      handler: function handler() {
        this.fetchShipments();
      }
    }
  }
};